import React, { useState } from "react";
import { Stack } from "@mantine/core";
import WebsiteURLBuiltInDomain from "./WebsiteURLBuiltInDomain";
import WebsiteURLCustomDomain from "./WebsiteURLCustomDomain";
import { BusinessInfo } from "../../../types/context";

interface WebsiteURLManagementProps {
  businessInfo?: BusinessInfo | null;
}

const WebsiteURLManagement: React.FC<WebsiteURLManagementProps> = ({
  businessInfo,
}) => {
  const [selectedDomainType, setSelectedDomainType] = useState<
    "built-in" | "custom"
  >("built-in");

  const handleDomainTypeChange = (domainType: "built-in" | "custom") => {
    setSelectedDomainType(domainType);
  };

  return (
    <Stack gap="md">
      {selectedDomainType === "built-in" ? (
        <WebsiteURLBuiltInDomain
          onDomainTypeChange={handleDomainTypeChange}
          businessInfo={businessInfo}
        />
      ) : (
        <WebsiteURLCustomDomain
          onDomainTypeChange={handleDomainTypeChange}
          businessInfo={businessInfo}
        />
      )}
    </Stack>
  );
};

export default WebsiteURLManagement;
